(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('UnitMachinesReportFranchiserController', UnitMachinesReportFranchiserController);

    /** @ngInject */
    function UnitMachinesReportFranchiserController($q, UnitService, UnitMachineService, HelperService, NotifyService) {
        const vm = this;

        let forcePaginationReset = false;
        let currentOrderBy = 'UnitName';
        let currentOrderDescending = false;

        vm.changeStatus = status => {
            vm.searchStatus = status;
        };

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                vm.appliedFilters = buildFilterParameters();
                forcePaginationReset = true;
                vm.tableCallServer();
            }
        };

        vm.clearSearch = () => {
            vm.selectedUnit = null;
            vm.selectedCategory = null;
            vm.selectedManufacturer = null;
            vm.selectedModel = null;
            vm.selectedSearchField = null;
            vm.searchText = null;
            vm.searchStatus = 0;
            vm.appliedFilters = {};
            forcePaginationReset = true;
            vm.tableCallServer();
        };

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            currentOrderBy = tableState.sort.predicate || 'UnitName';
            currentOrderDescending = tableState.sort.reverse || false;

            getMachines(start, number, tableState);
        };

        vm.exportExcel = () => {
            if (!vm.totalRecords || vm.isExporting)
                return;

            vm.isExporting = true;

            const parameters = angular.extend({}, vm.appliedFilters, {
                OrderBy: currentOrderBy,
                OrderDescending: currentOrderDescending
            });

            UnitMachineService
                .exportReport(parameters)
                .then(response => {
                    const contentDisposition = response.headers('content-disposition');
                    const fileName = getFileName(contentDisposition);
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    downloadBlob(blob, fileName);
                }, error => {
                    NotifyService.error(getExportErrorMessage(error));
                })
                .finally(() => {
                    vm.isExporting = false;
                });
        };

        init();

        function getMachines(skip, perPage, tableState) {
            vm.isLoading = true;

            const parameters = angular.extend({}, vm.appliedFilters, {
                Skip: skip,
                PerPage: perPage,
                OrderBy: currentOrderBy,
                OrderDescending: currentOrderDescending
            });

            UnitMachineService
                .getReport(parameters)
                .then(success => {
                    vm.machines = success.Machines;
                    vm.totalRecords = success.TotalRecords;
                    tableState.pagination.numberOfPages = success.NumberOfPages;
                    vm.isLoading = false;
                }, error => {
                    vm.machines = [];
                    vm.totalRecords = 0;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                });
        }

        function buildFilterParameters() {
            const parameters = {};

            if (vm.selectedUnit)
                parameters.UnitId = vm.selectedUnit.Id;

            if (vm.selectedCategory)
                parameters.MachineCategoryId = vm.selectedCategory.Id;

            if (vm.selectedManufacturer)
                parameters.MachineManufacturerId = vm.selectedManufacturer.Id;

            if (vm.selectedModel)
                parameters.Model = vm.selectedModel.Name;

            if (vm.searchStatus > 0)
                parameters.Active = vm.searchStatus == 1;

            if (vm.selectedSearchField && vm.searchText) {
                parameters.SearchField = vm.selectedSearchField.Value;
                parameters.SearchQuery = vm.searchText;
            }

            return parameters;
        }

        function getAllUnitsResumed() {
            return UnitService
                .getAllResumed()
                .then(success => {
                    vm.units = success;
                }, error => {
                    HelperService.errorCallback(error);
                });
        }

        function getCategories() {
            return UnitMachineService
                .getCategories()
                .then(success => {
                    vm.categories = success;
                }, error => {
                    HelperService.errorCallback(error);
                });
        }

        function getManufacturers() {
            return UnitMachineService
                .getManufacturers()
                .then(success => {
                    vm.manufacturers = success;
                }, error => {
                    HelperService.errorCallback(error);
                });
        }

        function getModels() {
            return UnitMachineService
                .getModels()
                .then(success => {
                    vm.models = success;
                }, error => {
                    HelperService.errorCallback(error);
                });
        }

        function getFileName(contentDisposition) {
            if (contentDisposition) {
                const match = /filename="?([^"]+)"?/i.exec(contentDisposition);

                if (match && match[1])
                    return match[1];
            }

            return `relatorio-equipamentos-${moment().format('YYYY-MM-DD')}.xlsx`;
        }

        function downloadBlob(blob, fileName) {
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
                return;
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }

        function getExportErrorMessage(error) {
            const fallbackMessage = 'Nao foi possivel gerar o relatorio de equipamentos.';

            if (!error || !error.data)
                return fallbackMessage;

            try {
                const bytes = new Uint8Array(error.data);
                let text = '';

                for (let index = 0; index < bytes.length; index += 8192) {
                    const chunk = bytes.subarray(index, Math.min(index + 8192, bytes.length));
                    text += String.fromCharCode.apply(null, chunk);
                }

                try {
                    text = decodeURIComponent(escape(text));
                } catch (decodeError) {
                    // The response can already be decoded in older browsers.
                }

                const response = angular.fromJson(text);
                return response.ErrorMessage || fallbackMessage;
            } catch (parseError) {
                return fallbackMessage;
            }
        }

        function init() {
            vm.units = [];
            vm.categories = [];
            vm.manufacturers = [];
            vm.models = [];
            vm.machines = [];
            vm.totalRecords = 0;
            vm.searchStatus = 0;
            vm.appliedFilters = {};
            vm.isLoading = true;
            vm.isExporting = false;

            vm.searchFields = [{
                Value: 'InternalAssetCode',
                Description: 'Codigo patrimonial'
            }, {
                Value: 'SerialNumber',
                Description: 'Numero de serie'
            }, {
                Value: 'UnitName',
                Description: 'Nome da loja'
            }, {
                Value: 'UnitExternalCode',
                Description: 'Codigo da loja'
            }];

            HelperService.startLoading('.custom-filters');

            $q.all([
                getAllUnitsResumed(),
                getCategories(),
                getManufacturers(),
                getModels()
            ]).finally(() => {
                HelperService.stopLoading('.custom-filters');
            });
        }
    }
}());
